import React from "react"
import { IScheduleDocument, ISchedulePatternTemplate } from "../../../../../models"
import _ from "lodash"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import moment from "moment"
import ScheduleResourcePlannerWeeklyDailyItem from "./ScheduleResourcePlannerWeeklyDailyItem"
import ScheduleResourcePlannerWeeklyDailyByEmployeeItem from "./ScheduleResourcePlannerWeeklyDailyByEmployeeItem"
import ScheduleResourcePlannerWeeklyDailyByEmployeeNameList from "./ScheduleResourcePlannerWeeklyDailyByEmployeeNameList"
import AppStateStore from "../../../../../stores/AppStateStore"

interface IProps {
  schedules: IScheduleDocument[]
  viewByEmployee: boolean
  handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
  handleUnAssignEmployee(unAssignPatternTemplate: ISchedulePatternTemplate): void
}

const ScheduleResourcePlannerWeeklyItemCollapsed: React.SFC<IProps> = (props: IProps) => {
  const rowHeight = 40
  const dayLength = scheduleHelper.durationInDays(props.schedules)
  const startDate = scheduleHelper.getStartDate(props.schedules)
  const endDate = scheduleHelper.getEndDate(props.schedules)
  const allShiftTemplates = props.viewByEmployee ?
    scheduleHelper.getPatternTemplates(props.schedules).filter(item => item.AssignedUserId && item.AssignedUserId.length > 0).filter(i => !i.Deleted)
    : scheduleHelper.getPatternTemplates(props.schedules).filter(i => !i.Deleted)

  let dayDates = []
  for (let i = 0; i < dayLength; i++) {
    dayDates.push(moment(startDate).add(i, "day"))
  }

  let employeeList = []
  for (let i = 0; i < allShiftTemplates.length; i++) {
    if (employeeList.filter(item => item.Id === allShiftTemplates[i].AssignedUserId).length === 0) {
      employeeList.push({ Id: allShiftTemplates[i].AssignedUserId, Name: allShiftTemplates[i].AssignedUserName, ExternalId: allShiftTemplates[i].AssignedUserExternalId })
    }
  }

  return (
    <div>
      <div style={{ padding: 10, position: "relative" }} id="ScheduleViewPlace">
        <div style={{ display: "grid", gridTemplateColumns: "auto min-content", marginBottom: 15 }}>
          <div style={{ gridColumn: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 500 }}>
              {props.schedules.map((item, index) => <span key={index}>{item.Name}{index < (props.schedules.length - 1) ? ", " : null}</span>)}
            </div>
            <div style={{ fontSize: 10 }}>
              {moment(startDate).format("MM/DD/YY")} - {moment(endDate).format("MM/DD/YY")}
            </div>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          {!props.viewByEmployee && dayDates.length > 1 && dayDates.map(date =>
            <ScheduleResourcePlannerWeeklyDailyItem
              key={date}
              patternTemplates={allShiftTemplates}
              dayDate={date}
              viewByEmployee={props.viewByEmployee}
              handleAssignEmployee={props.handleAssignEmployee}
              handleUnAssignEmployee={props.handleUnAssignEmployee}
            />
          )}
          {props.viewByEmployee && [
            <div
              key="EmployeeNameList"
              style={{
                minWidth: 120,
                position: "sticky",
                left: AppStateStore.getLeftNavWidth(),
                zIndex: 10,
                backgroundColor: "white"
              }}
            >
              <ScheduleResourcePlannerWeeklyDailyByEmployeeNameList
                rowHeight={rowHeight}
                employeeList={employeeList}
              />
            </div>,
            dayDates.length > 1 && dayDates.map(date =>
              <div key={date} style={{ flex: 1 }}>
                <ScheduleResourcePlannerWeeklyDailyByEmployeeItem
                  rowHeight={rowHeight}
                  patternTemplates={allShiftTemplates}
                  dayDate={date}
                  employeeList={employeeList}
                />
              </div>
            )
          ]}
        </div>
        {!allShiftTemplates || allShiftTemplates.length == 0 &&
          <div style={{ textAlign: "center", padding: 30 }}><b>No Shifts</b></div>
        }
      </div>
    </div>
  )
}

export default ScheduleResourcePlannerWeeklyItemCollapsed